<!-- eslint-disable handle-callback-err -->
<template>
  <v-app-bar class="wrapper-app-bar">
    <v-container
      class="wrapper-toolbar pa-0"
      :class="{ 'wrapper-toolbar-mobile': (isMobile || isTablet) }"
      :style="{ 'left': $vuetify.rtl ? '0' : '', 'right': !$vuetify.rtl ? '0' : '' }"
    >
      <!--TOGGLE-BTN-->
      <div class="toggle-btn">
        <div
          v-if="(!isMobile && !isTablet)"
          class="d-flex align-center toggle-icon"
          :class="{ 'rotate': isMenuToggle }"
          @click="menuToggle"
        >
          <svg
            style="cursor: pointer;"
            width="18"
            height="18"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.26769 9.2275C1.25258 9.28963 1.2471 9.35371 1.25144 9.4175C1.23394 9.9175 1.41769 10.425 1.80019 10.8075L4.45019 13.46C4.5083 13.5181 4.57728 13.5642 4.65321 13.5957C4.72913 13.6271 4.81051 13.6433 4.89269 13.6433C4.97487 13.6433 5.05624 13.6271 5.13217 13.5957C5.20809 13.5642 5.27708 13.5181 5.33519 13.46C5.3933 13.4019 5.43939 13.3329 5.47084 13.257C5.50229 13.1811 5.51848 13.0997 5.51848 13.0175C5.51848 12.9353 5.50229 12.8539 5.47084 12.778C5.43939 12.7021 5.3933 12.6331 5.33519 12.575L2.76019 10H18.1252C18.2909 10 18.4499 9.93415 18.5671 9.81694C18.6843 9.69973 18.7502 9.54076 18.7502 9.375C18.7502 9.20924 18.6843 9.05027 18.5671 8.93306C18.4499 8.81585 18.2909 8.75 18.1252 8.75H2.97394L5.33519 6.3875C5.44432 6.26876 5.50333 6.11242 5.49988 5.95118C5.49643 5.78994 5.43077 5.63627 5.31665 5.52231C5.20253 5.40835 5.04877 5.34292 4.88753 5.33969C4.72628 5.33646 4.57003 5.39569 4.45144 5.505L1.80019 8.155C1.51024 8.44469 1.32319 8.82141 1.26769 9.2275ZM18.1252 3.75H9.37519C9.20943 3.75 9.05046 3.81585 8.93325 3.93306C8.81604 4.05027 8.75019 4.20924 8.75019 4.375C8.75019 4.54076 8.81604 4.69973 8.93325 4.81694C9.05046 4.93415 9.20943 5 9.37519 5H18.1252C18.2909 5 18.4499 4.93415 18.5671 4.81694C18.6843 4.69973 18.7502 4.54076 18.7502 4.375C18.7502 4.20924 18.6843 4.05027 18.5671 3.93306C18.4499 3.81585 18.2909 3.75 18.1252 3.75ZM18.1252 13.75H9.37519C9.20943 13.75 9.05046 13.8158 8.93325 13.9331C8.81604 14.0503 8.75019 14.2092 8.75019 14.375C8.75019 14.5408 8.81604 14.6997 8.93325 14.8169C9.05046 14.9342 9.20943 15 9.37519 15H18.1252C18.2909 15 18.4499 14.9342 18.5671 14.8169C18.6843 14.6997 18.7502 14.5408 18.7502 14.375C18.7502 14.2092 18.6843 14.0503 18.5671 13.9331C18.4499 13.8158 18.2909 13.75 18.1252 13.75Z"
              fill="black"
            />
          </svg>
        </div>
        <div
          v-else-if="(isMobile || isTablet)"
          class="d-flex align-center toggle-icon"
          @click="mobileMenuToggle"
        >
          <v-icon>mdi-menu</v-icon>
        </div>
      </div>
      <div
        class="d-flex align-center gap-3"
      >
        <v-btn
          v-if="!isMobile || isTablet"
          min-width="0"
          text
          small
          style="direction: rtl"
          color=""
          class="pa-0"
        >
          {{ today }}
        </v-btn>
        <v-menu
          bottom
          offset-y
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              min-width="0"
              text
              small
              v-bind="attrs"
              color=""
              :loading="loading"
              v-on="on"
              @click="getYears"
              class="pa-0"
            >
              {{ $t('Year') }} : {{ $store.state.year }}
            </v-btn>
          </template>
          <v-list
            :tile="false"
            nav
          >
            <v-list-item
              v-for="(year, i) in yearItems"
              :key="i"
              style="cursor: pointer"
              dense
              @click="changeYear(year)"
            >
              <v-list-item-title>{{ year.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="vertical-divider" v-if="!isMobile || isTablet"></div>
        <div class="d-flex align-center gap-3">
          <v-tooltip
            bottom
            v-if="!isMobile"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                @click="resize"
                style="width: auto;height: auto;"
              >
                <svg style="cursor: pointer;" width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1163 5H12.31V3.75H16.25V7.69H15V5.88375L11.6925 9.1925L10.8075 8.3075L14.1163 5ZM5 14.1163L8.3075 10.8075L9.1925 11.6925L5.88375 15H7.69V16.25H3.75V12.31H5V14.1163Z" fill="black"/>
                </svg>
              </v-btn>
            </template>
            <span>{{ $t('change-page-size') }}</span>
          </v-tooltip>
          <Updates v-if="!isMobile || isTablet" />
          <TemplateSetting
            v-if="!isMobile || isTablet"
          />
        </div>
        <div class="vertical-divider" v-if="!isMobile || isTablet"></div>
        <div
          class="d-flex align-center gap-3"
        >
          <UserHelp />
          <UserSupport />
          <UserHistory />
        </div>
        <div class="vertical-divider" v-if="!isMobile || isTablet"></div>
        <UserData />
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
import { mapState } from 'vuex'
import UserData from '@/views/dashboard/components/core/partial/UserData.vue'
import UserHelp from '@/views/dashboard/components/core/partial/UserHelp.vue'
import UserSupport from '@/views/dashboard/components/core/partial/UserSupport.vue'
import UserHistory from '@/views/dashboard/components/core/partial/UserHistory.vue'
import TemplateSetting from '@/views/dashboard/components/core/partial/TemplateSetting.vue'
import Updates from '@/views/dashboard/components/core/partial/Updates.vue'
import moment from 'moment-jalaali'

export default {
  data () {
    return {
      isMenuToggle: false,
      today: null,
      yearItems: [],
      loading: false
    }
  },
  components: {
    UserData,
    UserHelp,
    UserSupport,
    UserHistory,
    TemplateSetting,
    Updates
  },
  computed: {
    ...mapState(['isMenuExpanded'])
  },
  methods: {
    menuToggle () {
      if (this.$store.state.isMenuExpanded) {
        this.$store.commit('SET_MENU_EXPANDED', false)
        document.documentElement.style.setProperty('--dynamic-width', '70px')
      } else {
        this.$store.commit('SET_MENU_EXPANDED', true)
        document.documentElement.style.setProperty('--dynamic-width', '200px')
      }
    },
    mobileMenuToggle () {
      const currentValue = this.$store.state.isMobileMenuOpen
      this.$store.commit('SET_MOBILE_MENU', !currentValue)
    },
    resize () {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen()
      } else {
        document.exitFullscreen()
      }
    },
    setToday () {
      var m = moment()
      if (this.$store.state.date_locale === 'fa,en') {
        // Get the Shamsi year, month, and day using moment-jalaali
        const shamsiYear = m.jYear() // Shamsi (Persian) year
        const shamsiMonth = m.jMonth() + 1 // Shamsi (Persian) month (starts from 1)
        const shamsiDay = m.jDate() // Day number in Shamsi calendar

        // Get Persian month names
        const persianMonths = [
          'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور',
          'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'
        ]

        // Format the date as 'year/month/day' in Shamsi
        this.today = `${shamsiDay}/${persianMonths[shamsiMonth - 1]}/${shamsiYear}`
      }
      if (this.$store.state.date_locale === 'en,fa') {
        this.today = m.format('YYYY/MM/DD')
      }
    },
    getYears () {
      var app = this
      app.loading = true
      app.$axios.get(this.$endpoint + 'getdetail', {
        params: {
          select: 'year',
          search: null,
          page: 1
        }
      })
        .then(res => {
          res = res.data
          app.yearItems = res.data
          app.allYears = res.data
          if (app.allYears && app.allYears.length > 0 && app.$store && app.$store.state.financialYear && app.$store.state.financialYear.id === app.allYears[0].id) {
            app.$store.commit('SET_ISMAINYEAR', true)
          } else {
            app.$store.commit('SET_ISMAINYEAR', false)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(err => {
          /* this.serverErrorHandeler(err) */
        })
        .finally(() => (app.loading = false))
    },
    /*   changeYear (item) {
      if (this.$store.state.financialYear.id === item.id) return false
      var app = this
      app.loading = true
      app.$axios.get(this.$endpoint + 'getdetail', {
        params: {
          select: 'changeYear',
          year: item
        }
      })
        .finally(() => (app.loading = false))
    }, */
    changeYear (item) {
      if (this.$store.state.financialYear.id === item.id) return false
      var app = this
      app.loading = true
      app.$axios.get(this.$endpoint + 'getdetail', {
        params: {
          select: 'changeYear',
          year: item
        }
      })
        .then(res => {
          res = res.data
          var storage = JSON.parse(localStorage.getItem('token'))
          storage.init.startDate = res.start_date
          storage.init.endDate = res.end_date
          storage.init.financialYear = res
          storage.init.year = res.name
          localStorage.setItem('token', JSON.stringify(storage))

          app.$store.commit('SET_YEAR', res.name)
          app.$store.commit('SET_FINANCIALYEAR', res)
          app.$store.commit('SET_START_DATE', res.start_date)
          app.$store.commit('SET_END_DATE', res.end_date)
          // app.$store.commit('CLEAR_COMPONENTS', [])
          location.reload()
        })
        // eslint-disable-next-line handle-callback-err
        .catch(err => {
          /* this.serverErrorHandeler(err) */
        })
        .finally(() => (app.loading = false))
    }
  },
  watch: {
    isMenuExpanded (val) {
      this.isMenuToggle = !this.isMenuToggle
    },
    year (val, oldVal) {
      this.changeYear(val)
    }
  },
  mounted () {
    this.setToday()
    this.getYears()
    const isMenuExpanded = this.$store.state.isMenuExpanded
    const dynamicWidth = isMenuExpanded ? '200px' : '70px'
    document.documentElement.style.setProperty('--dynamic-width', dynamicWidth)
  }
}
</script>

<style>
.wrapper-app-bar {
  height: 50px !important;
  padding: 0 8px;
  position: fixed;
  z-index: 3;
  display: flex;
  align-items: center;
  box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 0%), 0px 4px 5px 0px rgb(0 0 0 / 0%), 0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
}
.wrapper-app-bar .wrapper-toolbar {
  position: absolute;
  width: calc(100% - var(--dynamic-width));
  transition: width .2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.wrapper-app-bar .wrapper-toolbar.wrapper-toolbar-mobile {
  width: 100%;
}
:root {
  --dynamic-width: 200px;
}
.wrapper-app-bar .wrapper-toolbar .toggle-icon {
  transition: transform 0.3s ease-in-out;
  transform: rotate(0deg);
}
.wrapper-app-bar .wrapper-toolbar .toggle-icon.rotate {
  transform: rotate(180deg);
}
.wrapper-app-bar .v-toolbar__content {
  height: 60px !important;
  width: 100%;
}
.wrapper-app-bar .wrapper-toolbar .vertical-divider {
  border: 0.01rem solid #f0eeee82;
  height: 40px;
}
</style>
